var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container wizard-content lg:tw-py-12 relative"},[_c('transition',{attrs:{"name":"slide-fade","mode":"out-in","appear":""}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }